import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

function useCookieWithListener(cookieRegex: RegExp) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!('cookieStore' in window)) return;

    const changeListener = (event: any) => {
      const foundCookie = event.changed.find((cookie: any) => cookieRegex.test(cookie.name))
      if (foundCookie) {
        const newValue = Cookies.get(foundCookie.name);
        setValue(newValue);
      } else {
        setValue('');
      }
    };

    (window as any).cookieStore.addEventListener('change', changeListener);
    return () => (window as any).cookieStore.removeEventListener('change', changeListener);
  }, [ cookieRegex ]);

  return [ value ];
}

export default useCookieWithListener;
